import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-fsv-report',
  templateUrl: './fsv-report.component.html',
  styleUrls: ['./fsv-report.component.scss']
})
export class FsvReportComponent implements OnInit {

  constructor(private route: ActivatedRoute, private cryptoJsService: CryptoJsService, private router: Router) { }


  items: any[];
  autoId: any;
  appId: any;

  activeItem: any;

  ngOnInit() {
    let parentRoute = this.router.url.split('/')[1];
    this.route.queryParams
      .subscribe(params => {
        this.autoId = params.autoId;
        this.appId = params.appId;
        this.items = [
          { label: 'Month Wise', routerLink: `/${parentRoute}/report/fsv/month-wise`},
          { label: 'District Wise', routerLink: `/${parentRoute}/report/fsv/district-wise` },
          { label: 'Vendor Wise',routerLink: `/${parentRoute}/report/fsv/vendor-wise` },
          
        ];
      }
      );
  }

}
